<template>
  <b-modal
    ref="create-confirm-modal"
    hide-footer
    hide-header
    id="create-confirm-modal"
    no-close-on-backdrop
    no-close-on-esc
    class="centered-modal"
    :class="data.class"
  >
    <h3 v-if="data.title" class="text-center text-primary">
      {{ data.title }}
    </h3>
    <p v-if="data.description" class="mb-3 text-center">
      {{ data.description }} <span
        v-if="data.modalType === 'emptyFolder' || data.modalType === 'removeFolder'"
      >
        <strong class="break-word">{{ data.folder.folderName }}</strong>
        <span v-if="data.modalType === 'emptyFolder'">
          <span>? <br> It contains no presentation.</span>
        </span>
      </span>
      <span v-if="data.modalType == 'deletePresentation' || data.modalType == 'eraseData'">
        <span
          class="font-weight-bold"
        >{{ data.data.item.name }} [{{ data.data.item.accessCode }}]</span>
        <span>?</span>
        <span v-if="data.modalType == 'eraseData'"> {{ data.moreDesc }}</span>
      </span>

      <!-- Remove folder content -->
      <span v-if="data.modalType === 'removeFolder'">
        <span
          v-if="data.folder.presentations.length === 1"
        > and its presentation? <br>It contains 1 presentation:</span>
        <span
          v-else
        > and its presentation? <br>
          It contains {{ data.folder.presentations.length }} presentations:
        </span>
      </span>
    </p>
    <div v-if="data.modalType === 'removeFolder'" class="mb-3 folder-content">
      <ul class="mb-0 overflow-auto folder-content-list">
        <li
          v-for="presentation in data.folder.presentations"
          :key="presentation.id"
        >
          {{ presentation.name }}
        </li>
      </ul>
    </div>
    <div
      v-if="(data.modalType == 'singleQuizReminder' ||
        data.modalType == 'pluralQuizReminder') &&
        data.slidesInfo.length"
      class="reminder-content"
    >
      <ul class="mb-0">
        <li
          v-for="(slide, slideIndex) in data.slidesInfo"
          :key="slideIndex"
          class="text-left reminder-content-item"
        >
          Slide {{ slide.index }}: {{ slide.title }}
        </li>
      </ul>
    </div>
    <div
      v-if="data.checkBox"
      class="form-check form-check-inline"
      :class="{'single-reminder': data.modalType == 'singleQuizReminder'}"
    >
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="check-correct-answer-reminder"
          v-model="$store.state.presentation.notRemindCorrectAnswer"
        >
        <label
          class="custom-control-label pointer"
          for="check-correct-answer-reminder"
        >{{ data.checkBox }}</label>
      </div>
    </div>

    <div class="text-center">
      <button
        type="button"
        class="btn m-r-10 confirm-modal-ok-btn"
        :class="data.styleOk || 'btn-primary'"
        @click="ok"
      >
        {{ data.textOk || 'OK' }}
        <!-- Erase data ok btn -->
        <div
          v-if="data.modalType == 'eraseData' && data.isClearingData || data.isLoading"
          class="loading-spinner mb--1px ml-4px"
          :class="data.styleLoading || ''"
        />
        <div
          v-if="(data.modalType === 'emptyFolder' || data.modalType === 'removeFolder')
            && isRemovingFolder"
          class="loading-spinner mb--1px ml-4px"
        />
      </button>
      <button
        type="button"
        class="btn"
        :class="data.styleCancel || 'btn-light'"
        v-if="!data.noCancelBtn"
        @click="hide"
      >
        {{ data.textCancel || 'Cancel' }}
        <span v-if="data.modalType == 'confirmQuiz'">(auto hide in {{ countTime }})</span>
      </button>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Utils from '@/util'
import constants from '@/constant'
import EventBus from '@/eventBus'
import FolderApi from '@/api/folder'

const { gaCategories } = constants

export default {
  name: 'ConfirmModal',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      countTime: 7,
      intervalCountTime: null,
      isRemovingFolder: false,
    }
  },
  computed: {
    ...mapState({
      folders: (state) => state.folders,
    }),
  },
  mounted() {
    this.show()
    if (this.data.modalType === 'confirmQuiz') {
      this.countTime = 7
      this.intervalCountTime = setInterval(() => {
        this.countTime--
        if (this.countTime < 1) {
          this.countTime = 0
          this.clearInterval()
          this.hide()
        }
      }, 1000)
    }

    // Prevent deselect
    setTimeout(() => {
      const modal = document.getElementById('create-confirm-modal')
      if (modal) {
        modal.addEventListener('mouseup', (e) => {
          e.stopPropagation()
        }, true)
      }
    }, 0)
  },
  destroyed() {
    this.$store.state.quizConfirmation = false
    this.$store.state.quizConfirmationType = null
    this.clearInterval()
  },
  methods: {
    ...mapActions([
      'setFoldersAction',
    ]),
    clearInterval() {
      if (this.intervalCountTime) {
        clearInterval(this.intervalCountTime)
        this.intervalCountTime = null
      }
    },
    show() {
      this.$refs['create-confirm-modal'].show()
    },

    hide() {
      this._closePopup()
      this.$emit('interface', {
        open: false,
        ok: false,
      })
      this.clearInterval()
      if (this.data.modalType === 'confirmQuiz') {
        Utils.gaTrackEvent('Quiz Exit Confirmation', 'Quiz Exit Confirmation stay', 'Quiz Exit Confirmation stay')
      }

      if (this.data.modalType === 'eraseData') {
        Utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Presentation > Erase data > Cancel')
      }

      if (this.data.modalType === 'deletePresentation') {
        Utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Presentation > Delete > Cancel')
      }

      if (this.data.modalType === 'emptyFolder' || this.data.modalType === 'removeFolder') {
        this.isRemovingFolder = true
        Utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Folder > Delete > Cancel')
      }
    },

    _closePopup() {
      this.$refs['create-confirm-modal'].hide()
      this.$emit('handleModalConfirmCancel')
    },

    async ok() {
      if (this.data.modalType === 'emptyFolder' || this.data.modalType === 'removeFolder') {
        this.isRemovingFolder = true
        Utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Folder > Delete > Submit')

        try {
          await FolderApi.removeFolderById(this.data.folder.folderId)
          Utils.showToastSuccess(`Deleted folder "${this.data.folder.folderName}"`)
          Utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Folder > Delete > Succeeded')
        } catch {
          Utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Folder > Delete > Failed')
          Utils.showToastError('Delete folder failed')

          return
        } finally {
          this.isRemovingFolder = false
        }

        const index = this.folders.findIndex((folder) => {
          return folder.folderId === this.data.folder.folderId
        })

        this.folders.splice(index, 1)
        this.setFoldersAction(this.folders)
        this.$emit('handleModalConfirmOk', 'removeFolder')
        EventBus.$emit('reload-presentation-when-searching')
        this._closePopup()
        return
      }

      if (this.data.modalType === 'eraseData') {
        this.data.isClearingData = true
      }

      this.$emit('handleModalConfirmOk', this.data)
      this.data.open = false
      this.data.ok = true
      this.$emit('interface', this.data)
      this.clearInterval()
      if (this.data.modalType === 'confirmQuiz') {
        Utils.gaTrackEvent(
          'Quiz Exit Confirmation',
          'Quiz Exit Confirmation leave',
          'Quiz Exit Confirmation leave',
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.folder-content-list {
  max-height: 90px;
}
</style>
